
import { computed, defineComponent, ref, PropType } from '@vue/composition-api';

import { appStore } from '@/shared/config/store/app-store';
import { briefingStore } from '@/shared/config/store/briefing-store';

import { checkIsGuestAccount } from '@/util/guest-util';
import { onBookmark, offBookmark } from '@/v2/discovery/apis';
import { IResourceModel } from '@/shared/model/briefing-widget.model';

export default defineComponent({
  name: 'Bookmark',
  props: {
    item: {
      type: Object as PropType<IResourceModel>,
      required: true,
      default: () => {},
    },
    index: {
      type: Number as PropType<number>,
      required: false,
      default: 0,
    },
  },
  emits: ['onChangeBookmark'],
  setup(props, { emit }) {
    const { state, mutations } = appStore;
    const { state: briefingState, mutations: commit } = briefingStore;

    const now = Date.now();
    const isLoading = ref<boolean>(false);

    const onClickBookmark = async (item: IResourceModel) => {
      if (checkIsGuestAccount(true)) {
        return;
      }

      const isNotBookmarked = !item.isBookmarked;
      const originType = item.type === 'VIDEO' ? 'DISCOVERY' : item.type;
      isLoading.value = true;

      if (isNotBookmarked) {
        await onBookmark({
          requestId: now,
          originType,
          parentDocDetail: item.originParentDocDetail,
        }).then(res => {
          // console.log('res', res);
        });
      }

      if (!isNotBookmarked) {
        await offBookmark(now, item.docId).then(res => {
          // console.log('ress', res);
        });
      }

      isLoading.value = false;
      mutations.setToggleResource(state, true);

      emit('onChangeBookmark', { mode: 0, index: props.index });
    };

    return {
      isLoading,
      isBookmarked: computed(() => state.toggleResource),
      onClickBookmark,
    };
  },
});
